/**
 * Whether the current global context is a webview or not. Useful for
 * assessing functionality for certain features
 */
export const IS_WEBVIEW = /webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i.test(navigator.userAgent)
